export default {
	setCarrierList(state, data) {
		if (data) {
			state.carriers = data;
		}
	},

	createCarrier(state, data) {
		if (data) {
			state.carriers.push(data);
		}
	},
  
	editCarrier(state, data) {
		if (data) {
			const index = state.carriers.findIndex(carrier => carrier.id === data.id);
			state.carriers.splice(index, 1, data);
		}
	},
  
	deleteCarrier(state, data) {
		if (data) {
			state.carriers = state.carriers.filter(carrier => carrier.id !== data);
		}
	}
};
